import { create } from 'zustand';
import { produce } from 'immer';
import { Document } from '../apis/dtos';

export interface DocumentSlice {
  documents: Document[] | null;
  setDocuments: (documents: Document[]) => void;
}

// Use store slice pattern to create store
// https://github.com/pmndrs/zustand/blob/main/docs/guides/slices-pattern.md
const useDocumentStore = create<DocumentSlice>((set) => ({
  documents: null,
  setDocuments: (documents: Document[]) =>
    set(
      produce((state: DocumentSlice) => {
        state.documents = documents;
      }),
    ),
}));

export default useDocumentStore;
